(() => {
  if (customElements.get('show-more-button')) return;

  class ShowMoreButton extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('button');
      if (!button) return;

      button.addEventListener('click', (event) => {
        this.expandShowMore(event);
        const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
        if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
          const input = nextElementToFocus.querySelector('input');
          if (input) input.focus();
        }
      });
    }

    expandShowMore(event) {
      const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
      parentDisplay.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'));
      this.querySelectorAll('.label-text').forEach(element => element.classList.toggle('hidden'));
    }
  }

  customElements.define('show-more-button', ShowMoreButton);
})();
